<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close', 'confirm']);

const submit = async () => {
  emit('close');
  emit('confirm', true);
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="
        $t('CONVERSATION_MGMT.SYNPHONE_MEET.CONFIRMATION_MODAL.TITLE')
      "
    />
    <form class="flex flex-col items-start w-full" @submit.prevent="submit">
      <div class="w-full">
        <p>
          {{ $t('CONVERSATION_MGMT.SYNPHONE_MEET.CONFIRMATION_MODAL.MESSAGE') }}
        </p>
      </div>

      <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
        <Button
          faded
          slate
          type="reset"
          :label="
            $t(
              'CONVERSATION_MGMT.SYNPHONE_MEET.CONFIRMATION_MODAL.CANCEL_BUTTON'
            )
          "
          @click.prevent="emit('close')"
        />
        <Button
          type="submit"
          :label="
            $t(
              'CONVERSATION_MGMT.SYNPHONE_MEET.CONFIRMATION_MODAL.CONFIRMATION_BUTTON'
            )
          "
        />
      </div>
    </form>
  </div>
</template>
